/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { createSelector, createFeatureSelector } from '@ngrx/store';
import { EHealthCheckRequestState, IDeviceHealthCheckHistory } from '../../../device-health-check/models';
import { IAssetPlot, IStatusPanelItem, IVehiclePlot, IVehicleWithBoxResponse, IVehicleWithEsnResponse } from '../../models';

import { IDeviceHealthCheckState } from '../state';
import { getAssetPlots, getVehiclePlots } from './plots.selectors';

export const getDeviceHealthCheckState = createFeatureSelector<IDeviceHealthCheckState>('deviceHealthCheck');

export const getSelectedStatusItemId = createSelector(
  getDeviceHealthCheckState,
  (state: IDeviceHealthCheckState): number => state.selectedStatusItemId
);

export const getSelectedStatusItem = createSelector(
  getVehiclePlots,
  getAssetPlots,
  getSelectedStatusItemId,
  (vehiclePlots: IVehiclePlot[], assetPlots: IAssetPlot[], itemId: number): IStatusPanelItem => {
    let selectedStatusItem = vehiclePlots.find(vehiclePlot => vehiclePlot.id === itemId) as IStatusPanelItem;
    if (!selectedStatusItem) {
      selectedStatusItem = assetPlots.find(assetPlot => assetPlot.id === itemId) as IStatusPanelItem;
    }
    return selectedStatusItem;
  }
);

export const getVehicleWithBoxResponse = createSelector(
  getDeviceHealthCheckState,
  (state: IDeviceHealthCheckState): IVehicleWithBoxResponse => state.vehicleWithBoxResponse
);

export const getVehicleWithEsnResponse = createSelector(
  getDeviceHealthCheckState,
  (state: IDeviceHealthCheckState): IVehicleWithEsnResponse => state.vehicleWithEsnResponse
);

export const getPingRequestCorrelationId = createSelector(
  getDeviceHealthCheckState,
  (state: IDeviceHealthCheckState): string => state.pingRequestTransactionId
);

export const getPingState = createSelector(
  getDeviceHealthCheckState,
  (state: IDeviceHealthCheckState): EHealthCheckRequestState => state.pingState
);

export const getResetState = createSelector(
  getDeviceHealthCheckState,
  (state: IDeviceHealthCheckState): EHealthCheckRequestState => state.resetState
);

export const getHistory = createSelector(
  getDeviceHealthCheckState,
  (state: IDeviceHealthCheckState): IDeviceHealthCheckHistory[] => state.history
);

export const getHistoryLoading = createSelector(
  getDeviceHealthCheckState,
  (state: IDeviceHealthCheckState): boolean => state.historyLoading
);
